<template>
  <div>
    <template>
      <div class="loader">
        <v-progress-circular
            indeterminate
            color="primary"
            v-if="loading"></v-progress-circular>
      </div>
    </template>
    <v-data-table
        :headers="headers"
        :items="desserts"
        :search="search"
        :loading="isLoadingData"
        loading-text="Cargando datos...!!!"
        sort-by="billing_provider_id"
        class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar
            flat
        >
          <v-toolbar-title>Configuracion de tarjetas virtuales</v-toolbar-title>
          <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar (*todas las columnas)"
              single-line
              hide-details
              class="mx-8"></v-text-field>

          <v-divider
              class="mx-4"
              inset
              vertical
          ></v-divider>
          <v-spacer></v-spacer>

          <FrmVCConfigComponent ref="form" v-on:updateList="initialize" @changLoading="loadingChange"></FrmVCConfigComponent>

          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5">Seguro que quieres eliminar esta tarjeta?</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete">No eliminar</v-btn>
                <v-btn color="blue darken-1" text @click="deleteItemConfirm">Si, estoy seguro</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>

      </template>

      <template v-slot:item.actions="{ item }">

        <v-icon small class="mr-2" @click="viewItem(item)">
          mdi-eye-arrow-left
        </v-icon>
        <v-icon small class="mr-2" @click="editItem(item)">
          mdi-pencil
        </v-icon>
        <v-icon small @click="deleteItem(item)">
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
    <DetailsConfigComponent ref="detailsItems" @closeDetails="defaultValues" @changLoading="loadingChange"/>
  </div>
</template>
<style>
.loader {
  position: absolute;
  top: 50%;
  right:50%;
  z-index:10000000;
}
</style>
<script>

import FrmVCConfigComponent from '../components/FrmVCConfigComponent';
import DetailsConfigComponent from '../components/DetailsConfigComponent';
import axios from 'axios';
import getBaseUrl from '../utils/baseUrl';

export default {
  name: 'VCConfigList',
  data() {
    return {
      dialog: false,
      dialogDelete: false,
      isLoadingData: false,
      search: '',
      headers: [
        {
          text: 'Proveedores',
          align: 'start',
          value: 'billing_provider_name',
        },
        {text: 'Provedor de Pago', align: 'start', value: 'payment_provider_name'},
        {text: 'Tipo de cancelacion', align: 'start', value: 'cancellation_type'},
        {text: 'Correo electrónico', align: 'start', value: 'primary_email_notification'},
        {text: 'Emisor', align: 'start', value: 'vendor'},
        {text: 'Divisa', align: 'start', value: 'currency'},
        {text: 'Inicio de validez', align: 'start', value: 'validity_period_start_type'},
        {text: 'Fin de validez', align: 'start', value: 'validity_period_end_type'},
        {text: 'Plataforma', align: 'start', value: 'security_context_name'},
        {text: 'Actions', value: 'actions', sortable: false}
      ],
      desserts: [],
      loading: false,
    }
  },

  watch: {
    dialog(val) {
      val || this.close()
    },
    dialogDelete(val) {
      val || this.closeDelete()
    },

  },
  created() {
    this.initialize();
  },

  methods: {

    initialize() {
      this.isLoadingData = true;
      axios.get(`${getBaseUrl()}list`)
          .then(res => {
            this.desserts = res.data.data;
            this.isLoadingData = false;
          });
    },

    editItem(item) {

      this.$refs.form.editItem(item);
    },

    deleteItem(item) {

      this.editedIndex = this.desserts.indexOf(item);
      this.editedIndex = item.id;
      this.dialogDelete = true;
    },

    deleteItemConfirm() {

      this.loadingChange();

      axios.get(`${getBaseUrl()}delete`, {
        params: {
          id: this.editedIndex
        }
      })
          .then(res => {

            if (res.status == 200) {

              this.$refs.form.messageInfo("Eliminado correctamente");
            }

          }).catch(error => {
        this.$refs.form.messageInfo("La configuracion no se ha eliminado");
        console.log(error);
      }).finally(() => {

        this.loadingChange();
      })

      this.initialize();
      this.closeDelete()
    },

    closeDelete() {

      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedIndex = -1
      })
    },

    viewItem(item) {

      this.$refs.detailsItems.activate(item);
    },

    defaultValues() {

      this.$refs.form.defaultValues();
    },

    loadingChange() {

      this.loading = !this.loading
    }
  },
  components: {
    FrmVCConfigComponent,
    DetailsConfigComponent
  }
}
</script>
